import React from 'react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconUserShield } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '../../store/userStore';

/** Плашка «вы вошли под другим пользователем» с возвратом в свою сессию. */
export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const adminSession = useUserStore((s) => s.adminSession);
  const stopImpersonating = useUserStore((s) => s.stopImpersonating);
  const [isReturning, setIsReturning] = React.useState(false);

  if (!adminSession) return null;

  const handleReturn = async () => {
    setIsReturning(true);
    await stopImpersonating();
    // Кэш собран под чужими правами — админу он не подходит.
    queryClient.clear();
    navigate('/users');
  };

  return (
    <Alert color="yellow" icon={<IconUserShield size={16} />} mb="md" py="xs">
      <Group justify="space-between" wrap="wrap" gap="xs">
        <Text size="sm">{t('users.impersonating', { admin: adminSession.name })}</Text>
        <Button
          size="xs"
          variant="light"
          color="yellow"
          loading={isReturning}
          onClick={handleReturn}
        >
          {t('users.returnToAdmin', { name: adminSession.name })}
        </Button>
      </Group>
    </Alert>
  );
};
